<bic-popup (close)="cancel()" [hasBackdrop]="true" [title]="title" customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col">
    <span class="font-normal">{{ message }}</span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="cancel()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="confirm()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>

